module.exports = __webpack_public_path__ + "static/media/tallocate.fa465bbc.png";